/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface InventoryAlertDto
 */
export interface InventoryAlertDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAlertDto
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAlertDto
     */
    variantId: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAlertDto
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAlertDto
     */
    variantName: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryAlertDto
     */
    currentStock: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryAlertDto
     */
    alertType: InventoryAlertDtoAlertTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InventoryAlertDtoAlertTypeEnum {
    LOWSTOCK = 'LOW_STOCK',
    OUTOFSTOCK = 'OUT_OF_STOCK'
}

